var ItemStatus;
(function (ItemStatus) {
    ItemStatus["LIKED"] = "LIKED";
    ItemStatus["DISLIKED"] = "DISLIKED";
})(ItemStatus || (ItemStatus = {}));
export { ItemStatus };
